/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reorderColumn: {
		id: 'native-issue-table.issue-table.table-header.table-header-cell.column-actions',
		defaultMessage: 'Reorder {title} column',
		description:
			'Accessibility label for an icon that indicates to the user that a column has actions available',
	},
	moveLeft: {
		id: 'native-issue-table.issue-table.table-header.table-header-cell.move-left',
		defaultMessage: 'Move left',
		description: 'Text for an action that allows the user to move a column to the left',
	},
	moveRight: {
		id: 'native-issue-table.issue-table.table-header.table-header-cell.move-right',
		defaultMessage: 'Move right',
		description: 'Text for an action that allows the user to move a column to the right',
	},
	warningLabel: {
		id: 'native-issue-table.issue-table.table-header.dnd-focused',
		defaultMessage: 'Warning',
		description: 'Label for warning icon on a table header cell',
	},
});
